<img src="../../../../assets/images/header-image-radius.svg" style="display: block" />
<ng-content />
<img src="../../../../assets/images/header-image-radius.svg" style="transform: scaleX(-1); display: block" />
